import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { VendorModule } from '../../../../../../modules/information/vendor';

const urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

@Component({
    selector: 'app-edit-vendor',
    templateUrl: './edit-vendor.component.html'
})

export class EditVendorComponent implements OnInit {
    orgID: any;
    vendorID: any;
    vendorModuleData = VendorModule;
    enableForm: boolean;

    public vendorData:any;
    /* Edit Vendor Form Variables */
    public editVendorForm:FormGroup;
    public formSubmitted:boolean = false;
    matFormSize = '13px';
    public updateValues=[];
    

    constructor(
        public api: ApiService,
        public router: Router,
        public route: ActivatedRoute,
        public swal: SweetAlert,
        public storage: StorageService,

    ) {
        this.route.paramMap.subscribe((params: any) => {
            this.vendorID=params.params.vendorID;
          });
          this.orgID = this.storage.get('userInfo').orgID;
    }
    ngOnInit() {
        this.addFormLoad();
        this.getVenderData();
    }

    
  addFormLoad(){
    this.editVendorForm = new FormGroup({
      vendorName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      landline: new FormControl('', [Validators.required,Validators.pattern('[0-9]\\d{9}')]),
      zone: new FormControl('', [Validators.required,Validators.pattern('[a-z|A-Z_ ]*')]),
      address: new FormControl('', [Validators.required]),
      pincode: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{5}')]),
      domain: new FormControl('', [Validators.required,Validators.pattern(urlPattern)]),     
    });
  }
  /* Invidual form field check */
  public checkError = (controlName: string, errorName: string) => {
    return this.editVendorForm.controls[controlName].hasError(errorName);
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


    getVenderData() {
        const obj = {
            orgID: this.orgID,
            vendorID: this.vendorID
        };
        this.api.transportManagerVendorList(obj).then((res: any) => {
            if (res.status == 'success') {
                this.vendorData = res.data[0];
                this.patchVendorData();
            }
            if (res.status == 'failure') {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }

        }).catch((err) => {
            console.log(err);
        });
    }

    patchVendorData() {
        this.editVendorForm.patchValue({
            vendorName: this.vendorData.vendorName,
            email: this.vendorData.email,
            mobile: this.vendorData.mobile,
            landline: this.vendorData.landline,
            zone: this.vendorData.zone,
            address: this.vendorData.address,
            pincode: this.vendorData.pincode,
            domain: this.vendorData.domain,         
        });
    }

    fieldChange(e:any,type,field){
        if(type=='text' || type=='textarea'){
          let value = e.target.value;
          if((field=='email' || field=='domain') && value !='') value = value.toLowerCase();
          this.updateField(field,value);
        }
        if(type=='date' || type=='dropdown'){
          this.updateField(field,e.value);
        }
        if(type=='file'){
          this.updateField(field,e);
        }
      }

    updateField(field,value){
        if(this.updateValues.length>0){
          let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
          let obj={field:field,value:value,};
          this.updateValues=[
            ...filterUpdate,
            obj,
          ]
        }
        else{
          let obj={field:field,value:value,};
          this.updateValues.push(obj);
        }
        console.log(this.updateValues);
    }

    submitted() {
        this.formSubmitted = true;
        if(this.editVendorForm.valid && this.updateValues && this.updateValues.length>0){
            const obj = {
              orgID: this.orgID,
              vendorID: this.vendorID,
            };
            this.updateValues.filter((e)=>{
              obj[e.field]=e.value;
            });
          this.api.transportManagerVendorUpdate(obj).then((res: any) => {
              if (res.status == 'success') {
                  this.swal.swalFunction(res.status, res.status, res.message, 2000);
                  this.router.navigate(['/organization/transport-manager/information/vendor/view-vendor']);
              }
              if (res.status == 'failure') {
              this.swal.swalFunction('error', res.status, res.message, 2000);
              }
          }).catch((err) => {
              console.log(err);
          });
        }
    }
}
